export default "__VITE_ASSET__BK5$_p9c__"